import {
  ThemeUICSSObject,
  getColorsByPath,
  responsive,
  spacing,
} from '@apia/theme';

const gridCols = responsive({
  0: 'repeat(1, 1fr)',
  3: 'repeat(2, 1fr)',
  5: 'repeat(4, 1fr)',
});

const spanAll = responsive({
  0: 'span 1',
  3: 'span 2',
  5: 'span 4',
});

const spanHalf = responsive({
  0: 'span 1',
  5: 'span 2',
});

const decAdmGlobal: ThemeUICSSObject = {
  upsertion: {
    fieldset: {
      display: 'grid',
      gridTemplateColumns: gridCols,

      '&.notGrid': {
        display: 'block',
      },

      gap: spacing(4),
      p: spacing(7),
      border: 'none',
      ...getColorsByPath('tab'),

      '.flagContainer': {
        gridColumn: spanHalf,
        display: 'grid',
        flexDirection: 'column',
        alignItems: 'center',
        gap: spacing(4),
      },

      '.checkbox': {
        flexDirection: 'row-reverse',
        alignItems: 'center',
        justifyContent: 'start',
        gap: spacing(4),
        '.semicolon': {
          display: 'none',
        },
      },

      '.imageSelector': {
        gridColumn: spanHalf,
        alignItems: 'center',
        '.buttonContainer': {
          gridColumn: spanHalf,
          alignSelf: 'center',
          '&>div': { gap: spacing(0) },

          position: 'relative',
          '.deleteImage': {
            position: 'absolute',
            right: 0,
            top: 0,
            color: 'palette.text.primary',
            backgroundColor: 'white',
            borderRadius: '100%',
            p: '4px',
          },
          '.imageContainer': {
            p: spacing(4),
          },
        },
      },

      '.textarea': {
        textarea: {
          height: '15vh',
          mt: spacing(1),
        },
      },

      '.fldSpanAll': {
        gridColumn: spanAll,
      },

      '.fldSpanHalf': {
        gridColumn: spanHalf,
      },

      '& label': {
        alignItems: 'stretch',
      },
    },
  },

  security: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    '.security__menu': {
      display: 'flex',
      flexDirection: 'row',
      gap: '6px',
      mt: '20px',
      position: 'sticky',
      top: 0,
      zIndex: 'stickyElements',
      '.security__menu__search': {
        width: '88%',
      },
    },
    '.security__environments': {
      display: 'flex',
      flexDirection: 'column',
      gap: '6px',
    },
    '.security__environment': {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      border: '1px solid',
      borderColor: 'palette.gray.800',
      p: '20px',
    },
    '.security__filteredEnvironments': {
      display: 'flex',
      flexDirection: 'row',
      gap: '5px',
      '.security__filteredEnvironments__title': {
        fontWeight: 'bold',
      },
      '.security__filteredEnvironments__label': {
        fontStyle: 'italic',
      },
    },
    '.security__environment__header': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    '.security__environment__header__leftButtons': {
      display: 'flex',
      flexDirection: 'row',
      '.closeButton': {
        width: '30px',
        height: '30px',
        background: 'transparent',
        svg: {
          width: '30px',
          height: '30px',
        },
      },
    },
    '.security__environment__filterSwitch, .security__environment__isEnabled': {
      display: 'flex',
      width: '100%',
      justifyContent: 'end',
      gap: '10px',
    },
    '.security__environment__filterSwitch': {
      borderBottom: '1px solid',
      pb: '10px',
      pr: '30px',
      borderColor: 'palette.gray.800',
    },

    '.security__environment__pools__container, .security__environment__roles__container':
      { display: 'flex', flexDirection: 'column', gap: '6px' },
    '.security__environment__pools__title, .security__environment__roles__title, .security__environment__styles__title':
      { fontWeight: 'bold' },
    '.security__environment__pools, .security__environment__roles': {
      display: 'flex',
      flexDirection: 'row',
      gap: '6px',
      flexWrap: 'wrap',
      py: '5px',
    },
    '.security__environment__pool, .security__environment__role': {
      border: '1px solid',
      borderColor: 'palette.gray.800',
      background: 'palette.background.paper',
    },
    '.security__environment__stylesSelection': {
      width: '20%',
    },
    '.pools__empty, .roles__empty': {
      p: 5,
      border: '1px solid',
      borderColor: 'palette.gray.800',
      display: 'flex',
      width: '100%',
    },
    '.roles__add, .pools__add': {
      width: '20%',
    },
    '.closeButton': {
      padding: 0,
      height: 'fit-content',
      border: 'none',
    },
  },
};

export default decAdmGlobal;
